export enum triviaTestId {
  progressCircle = "trivia-progress-circle",
  bonusIndicator = "trivia-bonus-indicator",
  getReady = "trivia-prompt-get-ready",
  summaryHeader = "trivia-summary-header",
  scoreLabel = "trivia-summary-score-label",
  answerSymbols = "trivia-summary-answer-symbols",
  bonusScoreLabel = "trivia-summary-bonus-score-label",
  bonusAnswerSymbols = "trivia-summary-bonus-answer-symbols",
  summaryDetails = "trivia-summary-details",
  shareButton = "trivia-share-button",
  recommendations = "trivia-recommendations",
  questionList = "trivia-question-list",
  bonusQuestionList = "trivia-bonus-question-list",
  moreMenu = "trivia-more-menu",
  playAgain = "trivia-play-again",
  moreShare = "trivia-more-menu-share",
  leaderboardSection = "trivia-leaderboard",
  leaderboardRow = "trivia-leaderboard-row",
}

export const triviaQuestionTestId = (qid: number | string) =>
  `trivia-question-${qid}`;

export const triviaAnswerTestId = (aid: number | string) =>
  `trivia-answer-${aid}`;

export const triviaAnswerSliderTestId = (aid: number | string) =>
  `trivia-slider-${aid}`;

export const triviaQuestionExplanationTestId = (qid: number | string) =>
  `trivia-explanation-${qid}`;
